import { isOldAlicUlPolicy, isWholeLifePolicy } from "js/utilities";

export const getPolicyType = (policy) => {
  if (!policy?.product?.type) return "";

  const policyType = policy.product.type.toUpperCase();

  if (isWholeLifePolicy(policyType)) return "Whole Life";
  if (isOldAlicUlPolicy(policy)) return "Universal Life";

  const policyTypeMapping = {
    AF: "Single Premium Immediate Annuity",
    AI: "Indexed",
    AIR: "Registered Indexed Annuity",
    AP: "Deferred Annuity",
    APR: "Deferred Registered Annuity",
    AS: "Single Premium Deferred Annuity",
    AR: "Buyouts",
    AT: "Structured Settlements",
    LT: "Term Life",
    LT1: "Term Life",
    LTU: "Term Life",
  };

  return policyTypeMapping[policyType] || "";
};
